<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item">
          <router-link :to="'/dashboard'" class="nav-link"><i class="icon-speedometer"></i> Dashboard </router-link>
        </li>
        <!--<li class="nav-title">-->
        <!--UI Elements-->
        <!--</li>-->

        <template v-for="(section, key) in sections" v-if="isSectionVisible(key)">
          <a tag="li" class="nav-item nav-dropdown" disabled>
            <div style="font-weight: bold;" class="nav-link nav-dropdown-toggle" @click="handleClick"><i
                :class="section.icon"></i> {{ section.name }}</div>
            <ul class="nav-dropdown-items">
              <template v-for="(route, chKey) in routes" v-if="route.parent == key">
                <li class="nav-item" v-if="isAccessible(chKey, route.permissions)">
                  <router-link style="font-size: 13px; padding-left: 28px; background: rgb(66, 81, 88) !important;"
                    :to="route.url" class="nav-link" exact>
                    <i style="font-size: 13px;" :class="route.icon"></i>
                    {{ route.name }}
                  </router-link>
                </li>
              </template>
            </ul>
          </a>
        </template>

        <!--<router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/components'}" disabled>-->
        <!--<div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="icon-puzzle"></i> Components</div>-->
        <!--<ul class="nav-dropdown-items">-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/components/buttons'" class="nav-link" exact><i class="icon-puzzle"></i> Buttons</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/components/social-buttons'" class="nav-link" exact><i class="icon-puzzle"></i> Social Buttons</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/components/cards'" class="nav-link" exact><i class="icon-puzzle"></i> Cards</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/components/forms'" class="nav-link" exact><i class="icon-puzzle"></i> Forms</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/components/modals'" class="nav-link" exact><i class="icon-puzzle"></i> Modals</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/components/switches'" class="nav-link" exact><i class="icon-puzzle"></i> Switches</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/components/tables'" class="nav-link" exact><i class="icon-puzzle"></i> Tables</router-link>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</router-link>-->
        <!--<router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/icons'}" disabled>-->
        <!--<div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="icon-star"></i> Icons</div>-->
        <!--<ul class="nav-dropdown-items">-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/icons/font-awesome'" class="nav-link" exact><i class="icon-star"></i> Font Awesome</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/icons/simple-line-icons'" class="nav-link" exact><i class="icon-star"></i> Simple Line Icons</router-link>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</router-link>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/widgets'" class="nav-link" exact><i class="icon-calculator"></i> Widgets <span class="badge badge-info">NEW</span></router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/charts'" class="nav-link" exact><i class="icon-pie-chart"></i> Charts</router-link>-->
        <!--</li>-->
        <!--<li class="divider"></li>-->
        <!--<li class="nav-title">-->
        <!--Extras-->
        <!--</li>-->
        <!--<li class="nav-item nav-dropdown">-->
        <!--<a class="nav-link nav-dropdown-toggle" href="#" @click="handleClick"><i class="icon-star"></i> Pages</a>-->
        <!--<ul class="nav-dropdown-items">-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/pages/login'" class="nav-link" exact><i class="icon-star"></i> Login</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/pages/register'" class="nav-link" exact><i class="icon-star"></i> Register</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/pages/404'" class="nav-link" exact><i class="icon-star"></i> Error 404</router-link>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<router-link :to="'/pages/500'" class="nav-link" exact><i class="icon-star"></i> Error 500</router-link>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</li>-->
      </ul>
    </nav>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import PermissionDeclarations from '../permissions/index';

export default {
  name: 'sidebar',
  data() {
    return {
      routes: [],
      sections: []
    };
  },
  computed: {
    ...mapGetters('Auth', [
      'permissionsMap',
      'user'
    ])
  },
  watch: {
    user: 'onPermissionsLoaded'
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    onPermissionsLoaded() {
      this.routes = [];
      this.sections = PermissionDeclarations.sections;
      for (const route in PermissionDeclarations.routes) {
        this.routes.push(PermissionDeclarations.routes[route]);
      }
    },

    isSectionVisible(name) {
      //          console.log("name", name);
      //          console.log("declarations", PermissionDeclarations);
      let count = 0;
      let visible = 0;
      for (const route in PermissionDeclarations.routes) {
        if (PermissionDeclarations.routes[route].parent === name) {
          count++;
          if (this.isAccessible(route, PermissionDeclarations.routes[route].permissions)) {
            visible++;
          }
        }
      }
      if (count > 0 && visible > 0) {
        return true;
      }
      return false;
    },

    isAccessible(name, permissions) {
      if (!permissions || permissions.length === 0) {
        return true;
      }

      if (Object.keys(this.permissionsMap).find((p) => permissions.includes(p))) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.onPermissionsLoaded();
  }
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}
</style>
